export class PasswordRule {

    name = 'PasswordRule';
    errorMessage = 'password_rule_failed';

    passes() {
        return true;
    }

    getViolation() {
        const params = this.getAttributes();

        return {
            message: this.errorMessage,
            attributes: params
        };
    }

    getAttributes() {
        return null;
    }
}
